import { FirebaseTimestamp } from '@/models/hardware.model';
import { ReportInfo } from '@/models/reportInfo.model';

export type Session = {
  clientId: string;
  therapistId: string;
  createdAt: string;
  reports: string[];
  date: FirebaseTimestamp;
  notes: string[];
  _mutationHistory: {
    mutationType: string;
    mutationDate: string;
    mutationBy: string;
  };
  status: SessionStatus;
  id: string;
  sessionTypeId: string;
  reportInfo?: ReportInfo[];
};

export type SessionCreationData = {
  clientId: string;
  therapistId: string;
  date: string;
  sessionTypeId: string;
};

export enum SessionStatus {
  Active = 'active',
  Archived = 'archived',
  Error = 'error',
}
